import React from 'react'
import { SearchSection } from './MyCourses'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Box, Grid2, List, Typography } from '@mui/material'
import { Constants } from '../../shared/constants'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import StudentTransaction from './StudentTransaction'
import { CoinEarned } from './StudentBanlaceTab'
import BalanceCom from '../../shared/components/student/BalanceCom'
import { coinedEarnData } from '../../data/coinedearn'
export const PiggyBank = () => {
  return (
    <Box>

      {/* <SearchSection /> */}
      <CustomDivider orientation='horizontal' />
      <Grid2 container spacing={"30px"}>
        <Grid2 container size={{ lg: 7, xs: 12 }}>
          <Grid2 children size={12}>
            <Box sx={{
              bgcolor: "blue.main",
              p: "35px 34px",
              borderRadius: "15px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "130px",
              gap: 1,
              flexDirection: { sm: "row", xs: "column" }
            }} >
              <Box>
                <Typography variant='h5' fontWeight={500} color='text.secondary' my={2}>Unlock Your Rewards with Piggy Bank Bonuses!</Typography>
                <Typography variant='h6' color='text.secondary'>Every saving brings you closer to exciting bonuses and rewards! Fill your piggy bank and watch your rewards grow</Typography>
              </Box>
              <img src={Constants.customImages.PiggyPicture} alt='piggyPicture' width={"224px"} />
            </Box>
          </Grid2>

          <Grid2 children size={12}>
            <NormalContainerWithHeader headerText={"My Balance History "}>
              <CoinEarned />
              <Box sx={{ display: "flex", justifyContent: "space-between", mx: "20px" }}>
                <Typography variant='body2' fontWeight={500}>25 Jan 2025</Typography>
                <Typography variant='body2' fontWeight={500}> {coinedEarnData.totol} <Typography variant='body2' component={"span"}>This month</Typography></Typography>
              </Box>
              <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
              <List sx={{ mx: 1 }}>
                {coinedEarnData.arr.map((item, index) => (
                  <>
                    <BalanceCom key={index} img={item.img} name={item.name} coin={item.coin} />

                  </>
                ))}
              </List>

            </NormalContainerWithHeader>
          </Grid2>
        </Grid2>
        <Grid2 children size={{ lg: 5, xs: 12 }}>
          <NormalContainerWithHeader headerText={"My Transaction"}>
            <StudentTransaction />
          </NormalContainerWithHeader>

        </Grid2>

      </Grid2>
    </Box>
  )
}
